module.exports = __webpack_public_path__ + "img/email_template.aaa01aad.svg";